import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "@src/components/UIElements/Button/index";
import RightArrowIcon from "@src/components/AccentIcons/RightArrowIcon";
import DashBorder from "@src/components/UIElements/DashBorder";
import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";
import { showApplyBundleBottomSheetAction } from "@src/components/BottomSheets/store/actions";
import { useState } from "react";
import BundleListCard from "./BundleListCard";

const Bundle = ({ bundleData ,meta}) => {
  const dispatch = useDispatch();
  const [isBenefitsModalOpen, setIsBenefitsModalOpen]  = useState(false);

  const handleShowModal = () => {
    setIsBenefitsModalOpen(prevState => !prevState)
  }
  function handleBundleList() {
    let currentBundleList = [...bundleData];
    if(meta?.isPurchased === 1 && meta?.bundleData?.isBundlingEnabled === 1) {
      return currentBundleList
    }
    currentBundleList = currentBundleList.filter(item => item?.courseType !== "DOUBTBUDDY");
    return currentBundleList;
  }
  const currentBundleListData = handleBundleList();
  return (
    <div className="bundleDiv">
      <div className="CouponTop blockSlide">
        <div className="Label">
          {t(
            "components.tabs.overview.components.bundle.index.bundleText",
            "Included in this bundle"
          )}
        </div>
        {Array.isArray(bundleData) && bundleData?.length > 2 ? (
          <Button
            className="viewALLBtnMobile"
            onClick={() => {
              handleShowModal();
              // newWebEngage("course_coupons_list_view", {
              //   action: "Coupon Code Viewed",
              // });
              // dispatch(showApplyBundleBottomSheetAction(true));
            }}
            style={{ marginRight: "0px" }}
          >
            {t(
              "components.tabs.overview.components.coupons.index.viewAllText",
              "View All"
            )}
            <RightArrowIcon />
          </Button>
        ) : (
          ""
        )}
      </div>
      <BundleListCard bundleData={bundleData?.slice(0,3)} meta={meta} />
      {isBenefitsModalOpen? 
      <Modal
        isBundle = "1"
        handleClose = {handleShowModal}
        header = "Included in this bundle"
      >
        <BundleListCard bundleData={bundleData} meta={meta} handleShowModal={handleShowModal}/>
      </Modal>
       : ""}
    </div>
  );
};
export default Bundle;
